import React from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

export default function MasterToast({
  onClose,
  open,
  message,
  severity = "success",
}) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        elevation={6}
        onClose={onClose}
        severity={severity}
        sx={
          severity === "success"
            ? {
                backgroundColor: "#2e7d32",
                color: "#ffffff",
                "& .MuiAlert-icon": {
                  color: "#ffffff",
                },
              }
            : undefined
        }
        variant="filled"
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
